import React from 'react';
import { Card } from 'react-bootstrap';
import './QuizzBtn.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import LexicalViewer from './editor/LexicalViewer';


const ViewArticle = ({content}) => {

  const getDate = () => {
    const date = new Date(content.date);
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="py-5">
      <Card className="shadow-lg">
        <Card.Header className="bg-primary text-white p-4">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="mb-0">Titre: {content.title}</h1>
              <h6 className="mb-2 text-white-50">
                By: {content.author} 
              </h6>
            </div>
          </div>
        </Card.Header>
        
        <Card.Body className="p-5">
          <div className="article-content" style={{ 
            lineHeight: '1.8',
            fontSize: '1.1rem',
            textAlign: 'justify'
          }}>
            <LexicalViewer 
                            content={content.contenu}
                            showCard={false}
                        />
          </div>
        </Card.Body>

        <Card.Footer className="bg-light p-4">
          <div className="d-flex justify-content-between align-items-center">
            {/* <div>
              <strong>Lue:</strong> | {content.lue} fois
            </div> */}
            <div>
              <strong>Partage:</strong> <a target='_blank' href={'https://api.whatsapp.com/send?text=' + window.location.href}><FontAwesomeIcon style={{color: '#128c7e'}} icon={faWhatsapp} /></a>
            </div>
            <div>
              <strong>Date Publication:</strong> {getDate()}
            </div>
          </div>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default ViewArticle;